__turbopack_context__.v({
  "container": "ModelGallery-module__yKk9ga__container",
  "content": "ModelGallery-module__yKk9ga__content",
  "email": "ModelGallery-module__yKk9ga__email",
  "emails": "ModelGallery-module__yKk9ga__emails",
  "emailsVisible": "ModelGallery-module__yKk9ga__emailsVisible",
  "enquire": "ModelGallery-module__yKk9ga__enquire",
  "fadeInItems": "ModelGallery-module__yKk9ga__fadeInItems",
  "link": "ModelGallery-module__yKk9ga__link",
  "linkActive": "ModelGallery-module__yKk9ga__linkActive",
  "linkWrapper": "ModelGallery-module__yKk9ga__linkWrapper",
  "linkWrapperHidden": "ModelGallery-module__yKk9ga__linkWrapperHidden",
  "links": "ModelGallery-module__yKk9ga__links",
  "menu": "ModelGallery-module__yKk9ga__menu",
  "menuHidden": "ModelGallery-module__yKk9ga__menuHidden",
  "menuVisible": "ModelGallery-module__yKk9ga__menuVisible",
  "portfolioLink": "ModelGallery-module__yKk9ga__portfolioLink",
  "spacing--lg": "ModelGallery-module__yKk9ga__spacing--lg",
  "spacing--md": "ModelGallery-module__yKk9ga__spacing--md",
  "spacing--sm": "ModelGallery-module__yKk9ga__spacing--sm",
  "spacing--xl": "ModelGallery-module__yKk9ga__spacing--xl",
  "spacing--xs": "ModelGallery-module__yKk9ga__spacing--xs",
  "spacing--xxl": "ModelGallery-module__yKk9ga__spacing--xxl",
  "spacing--xxs": "ModelGallery-module__yKk9ga__spacing--xxs",
  "spacing--xxxl": "ModelGallery-module__yKk9ga__spacing--xxxl",
  "spacing--xxxs": "ModelGallery-module__yKk9ga__spacing--xxxs",
  "title": "ModelGallery-module__yKk9ga__title",
});
